export default __webpack_public_path__ + "static/media/avatar.28219ab8.png";